import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toAppError } from './errors';
import { TIMING } from '@/config/constants';
import { ErrorCode, ERROR_MESSAGES } from '@/config/error-messages';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const appError = toAppError(error);
      // Only toast for queries that already had data (background refetch failures).
      // First-load failures are handled per-page via isError.
      if (query.state.data !== undefined) {
        toast.error(appError.userMessage);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      const hasLocalHandler = mutation.options.onError != null;
      if (!hasLocalHandler) {
        const appError = toAppError(error);
        if (appError.code === ErrorCode.AUTH_FAILED) {
          toast.error(ERROR_MESSAGES[ErrorCode.SESSION_EXPIRED]);
        } else {
          toast.error(appError.userMessage);
        }
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: TIMING.QUERY_STALE_MS,
      gcTime: TIMING.QUERY_GC_MS,
      retry: (failureCount, error) => {
        const appError = toAppError(error);
        if (
          appError.code === ErrorCode.AUTH_FAILED ||
          appError.code === ErrorCode.FORBIDDEN ||
          appError.code === ErrorCode.NOT_FOUND
        ) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: true,
      throwOnError: false,
    },
    mutations: {
      throwOnError: false,
    },
  },
});
